import { updateListMethod } from '../../utils/list';
import {
  CURRICULUM_UPDATE_CURRICULUM_LIST,
  CURRICULUM_UPDATE_CURRICULUM_LIST_METHOD,
  CURRICULUM_CHANGE_CURRICULUM,
  CURRICULUM_UPDATE_LEVELS_LIST,
  CURRICULUM_UPDATE_LEVELS_LIST_METHOD,
  CURRICULUM_UPDATE_MARKING_LIST,
  CURRICULUM_UPDATE_MARKING_LIST_METHOD,
  CURRICULUM_UPDATE_LC_ELEMENTS_LIST,
  CURRICULUM_UPDATE_LC_ELEMENTS_LIST_METHOD,
  CURRICULUM_UPDATE_ELEMENTS_LIST,
  CURRICULUM_UPDATE_ELEMENTS_LIST_METHOD,
  CURRICULUM_UPDATE_ELEMENTS_STRUCTURE,
  CURRICULUM_UPDATE_SEMESTER_REPORT,
  CURRICULUM_UPDATE_SEMESTER_REPORT_LIST,
  CURRICULUM_UPDATE_SEMESTER_REPORT_LIST_METHOD
} from '../actions/curriculum.actions';

const initialState = {
  curriculums: [],
  lcElements: [],
  elements: {},
  elementsStructure: {},
  levels: [],
  marking: [],
  semesterReport: [],
  changeCurriculum: false
};

const curriculumReducer = (state = initialState, action) => {
  const newState = { ...state };
  const { type, payload } = action;

  switch (type) {
    case CURRICULUM_UPDATE_CURRICULUM_LIST:
      newState.curriculums = payload.data;
    break;
    case CURRICULUM_UPDATE_CURRICULUM_LIST_METHOD:
      newState.curriculums = updateListMethod(payload.method, payload.data, newState.curriculums);
    break;
    case CURRICULUM_CHANGE_CURRICULUM:
      newState.changeCurriculum = !newState.changeCurriculum;
    break;
    case CURRICULUM_UPDATE_LEVELS_LIST:
      newState.levels = payload.data;
    break;
    case CURRICULUM_UPDATE_LEVELS_LIST_METHOD:
      newState.levels = updateListMethod(payload.method, payload.data, newState.levels);
    break;
    case CURRICULUM_UPDATE_MARKING_LIST:
      newState.marking = payload.data;
    break;
    case CURRICULUM_UPDATE_MARKING_LIST_METHOD:
      newState.marking = updateListMethod(payload.method, payload.data, newState.marking);
    break;
    case CURRICULUM_UPDATE_LC_ELEMENTS_LIST:
      newState.lcElements = payload.data;
    break;
    case CURRICULUM_UPDATE_LC_ELEMENTS_LIST_METHOD:
      newState.lcElements.children = updateListMethod(payload.method, payload.data, newState.lcElements.children);
    break;
    case CURRICULUM_UPDATE_ELEMENTS_LIST:
      newState.elements = payload.data;
    break;
    case CURRICULUM_UPDATE_ELEMENTS_LIST_METHOD:
      const children = updateListMethod(payload.method, payload.data, newState.elements.children);
      newState.elements.children = children
    break;
    case CURRICULUM_UPDATE_ELEMENTS_STRUCTURE:
      newState.elementsStructure = payload.data;
    break;
    case CURRICULUM_UPDATE_SEMESTER_REPORT:
      newState.semesterReport = {
        assessment: payload?.data?.assessments || [],
        level: payload?.data?.levels || [],
        type: payload?.data?.types || []
      };
    break;
    case CURRICULUM_UPDATE_SEMESTER_REPORT_LIST:
      if (newState.semesterReport[payload.element]) {
        newState.semesterReport[payload.element] = payload.data;
      }
    break;
    case CURRICULUM_UPDATE_SEMESTER_REPORT_LIST_METHOD:
      if (newState.semesterReport[payload.element]) {
        newState.semesterReport[payload.element] = updateListMethod(payload.method, payload.data, newState.semesterReport[payload.element]);
      }
    break;
    default:
      break;
  }
  return newState;
};
export default curriculumReducer;